
import { Component, Vue } from 'vue-property-decorator'
import Navigator from './components/Navigator.vue'
import Spinner from '@/components/Spinner.vue'
import strings from '@/assets/strings.json'
import { Modal, VoerroModal } from '@voerro/vue-modal'
import { Api as ApiService } from '@/services/Api'

Vue.component('modal', Modal)

declare global {
  interface Window { VoerroModal: any }
}

window.VoerroModal = VoerroModal || {}

Vue.prototype.$apiService = new ApiService()

@Component({
  components: {
    Navigator,
    Spinner
  }
})
export default class App extends Vue {
  footerInfo = strings.FooterInfo

  get showSpinner (): boolean {
    return this.$store.state.loading
  }
}
